'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

///<reference path="../../../typings/tsd.d.ts" />
///<reference path="../../bindings/commons/API/Client/api.d.ts" />
var banks;
(function (banks) {
    var BanksService = function () {
        /*@ngInject*/

        function BanksService($http, $q) {
            _classCallCheck(this, BanksService);

            this.$http = $http;
            this.$q = $q;
            this.api = new API.Client.BankApi(this.$http);
        }

        _createClass(BanksService, [{
            key: 'getBanks',
            value: function getBanks() {
                return this.api.banksGet().then(function (response) {
                    return response.data.banks;
                });
            }
        }]);

        return BanksService;
    }();

    banks.BanksService = BanksService;
    angular.module('banks', []).service('banksService', BanksService);
})(banks || (banks = {}));